import { window } from "global";
import { useEffect } from "react";
import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";
import { PrivacyPolicyText } from "@ugitgud/legos/components/content/PrivacyPolicyText";

const PrivacyPolicy = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  return (
    <div className="text-content-container content-side-padding">
      {getPageTitleAndDesc("privacy_policy")}
      <div className="text-content">
        <PrivacyPolicyText />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
